import { IconNameV1 } from 'common/icon/iconV1.js';
import { MarkerTypeWaterActivity } from 'types/markerTypes/location-markers-type.js';
import { StatusRating } from 'utilities/status/status-rating.js';

/** comes from weather risk status */
export const getDefaultWaterMarkerIconName = (
  prefix: typeof MarkerTypeWaterActivity.Paddleboarding | typeof MarkerTypeWaterActivity.Kayak,
  rating?: StatusRating,
): IconNameV1 => {
  if (rating === StatusRating.statusBad) {
    return `${prefix}-${StatusRating.statusBad}`;
  }
  if (rating === StatusRating.statusMedium) {
    return `${prefix}-${StatusRating.statusMedium}`;
  }
  if (rating === StatusRating.statusGood) {
    return `${prefix}-${StatusRating.statusGood}`;
  }
  return `${prefix}-${StatusRating.statusDefault}`;
};
